// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__CUg7d","blackNextButton":"styles_blackNextButton__2fMp9","ant-btn-primary":"styles_ant-btn-primary__1sgRq"};